var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 11.4477 0.447715 11 1 11H2C2.55228 11 3 11.4477 3 12C3 12.5523 2.55228 13 2 13H1C0.447715 13 0 12.5523 0 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49309 3.49284C3.88361 3.10232 4.51678 3.10232 4.9073 3.49284L5.6073 4.19284C5.99783 4.58337 5.99783 5.21653 5.6073 5.60706C5.21678 5.99758 4.58361 5.99758 4.19309 5.60706L3.49309 4.90706C3.10256 4.51653 3.10256 3.88337 3.49309 3.49284Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C12.5523 0 13 0.447715 13 1V2C13 2.55228 12.5523 3 12 3C11.4477 3 11 2.55228 11 2V1C11 0.447715 11.4477 0 12 0Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5072 3.49284C20.8977 3.88337 20.8977 4.51653 20.5072 4.90706L19.8072 5.60706C19.4167 5.99758 18.7835 5.99758 18.393 5.60706C18.0025 5.21654 18.0025 4.58337 18.393 4.19285L19.093 3.49285C19.4835 3.10232 20.1167 3.10232 20.5072 3.49284Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12C21 11.4477 21.4477 11 22 11H23C23.5523 11 24 11.4477 24 12C24 12.5523 23.5523 13 23 13H22C21.4477 13 21 12.5523 21 12Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.393 18.3929C18.7835 18.0023 19.4167 18.0023 19.8072 18.3929L20.5072 19.0929C20.8977 19.4834 20.8977 20.1166 20.5072 20.5071C20.1167 20.8976 19.4835 20.8976 19.093 20.5071L18.393 19.8071C18.0025 19.4166 18.0025 18.7834 18.393 18.3929Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C12.5523 21 13 21.4477 13 22V23C13 23.5523 12.5523 24 12 24C11.4477 24 11 23.5523 11 23V22C11 21.4477 11.4477 21 12 21Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6073 18.3929C5.99783 18.7834 5.99783 19.4166 5.6073 19.8071L4.9073 20.5071C4.51678 20.8976 3.88361 20.8976 3.49309 20.5071C3.10256 20.1166 3.10256 19.4834 3.49309 19.0929L4.19309 18.3929C4.58361 18.0023 5.21678 18.0023 5.6073 18.3929Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7ZM5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.254298c1d4575ba5241d0faa856a9258.svg";
export { ForwardRef as ReactComponent };